import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, FormActions, Radio } from '../../common/components/formControls';
import TermsDropdownList from '../terms/DropdownList';
import CentersDropdownList from '../centers/DropdownList';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, grades, lessonCount,
	handleTermChange, paymentTypes, enableTermPrice, fixedTermPrice, enableTrials, t }) => {
	const showMonthPrice = paymentTypes.some(p => p.name === 'NormalMonth');
	const showSinglePrice = paymentTypes.some(p => p.name === 'NormalSingle');
	const showAnnualPrice = paymentTypes.some(p => p.name === 'Annual');
	const showTermPrice = enableTermPrice;

	const fixedTermPriceOptions = [
		{ value: 'false', label: t('Price_TermPrice_NotFixed') },
		{ value: 'true', label: t('Price_TermPrice_Fixed') }
	];

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<TermsDropdownList render='field' name='termId' horizontal required label={t('Price_Term')} onChange={handleTermChange} validate={validators.required} />
			<Field name='gradeId' component={Input} componentClass='select' horizontal required label={t('Price_Grade')} validate={validators.required}>
				<option />
				{ui.makeOptionValues(grades)}
			</Field>
			<CentersDropdownList render='field' name='centerId' horizontal required label={t('Price_Center')} validate={validators.required} />
			<Field name='pricePerLesson' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Price_PricePerLesson')} validate={[validators.required, validators.number]} />
			{showMonthPrice && <Field name='fourLessonPackagePricePerLesson' component={Input} disabled={isReadonly} horizontal type='text' label={t('Price_FourLessonPackagePricePerLesson')} placeholder={t('Price_UsePricePerLesson')} validate={[validators.number]} />}
			{showSinglePrice && <Field name='singleLessonPrice' component={Input} disabled={isReadonly} horizontal type='text' label={t('Price_SingleLessonPrice')} placeholder={t('Price_UsePricePerLesson')} validate={[validators.number]} />}
			{showAnnualPrice && <Field name='annualPrice' component={Input} disabled={isReadonly} horizontal type='text' label={t('Price_AnnualPrice', { lessonCount })} placeholder={t('Price_UsePricePerLesson')} validate={[validators.number]} />}
			{showTermPrice && <Field name='fixedTermPrice' component={Radio} entries={fixedTermPriceOptions} parse={value => value === 'true'} inline horizontal label={t('Price_TermPrice')} />}
			{showTermPrice && fixedTermPrice && <Field name='termPrice' component={Input} disabled={isReadonly} horizontal type='text' validate={[validators.number]} />}
			{enableTrials && <Field name='trialLessonPrice' component={Input} disabled={isReadonly} horizontal type='text' label={t('Price_TrialLessonPrice')} placeholder={t('Price_UseCenterDefault')} validate={[validators.number]} />}
			<FormActions horizontal>
				<Link to='/prices' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting || isReadonly} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'price', enableReinitialize: true })(withTranslation()(SettingsForm));

export const selector = formValueSelector('price');
